import env from "react-dotenv";
import { useQuery, gql } from '@apollo/client';
const axios = require('axios').default;

const API_URL = env.API_URL;

const LOGIN_VIA_CODE = `
  mutation Login($code: String!) {
    login(code: $code) {
      success
      code
      message
      token
    }
  }
`;

const LOGIN_VIA_CREDS = `
  mutation Login ($username: String!, $password: String!) {
    login(username: $username, password: $password) {
      success
      code
      message
      token
    }
  }
`;

const RESET_PASSWORD = `
mutation ResetPassword($email: String, $code: String, $password: String) {
  resetPassword(email: $email, code: $code, password: $password) {
    success
    message
  }
}
`;

const VERIFY_ACCOUNT = `
mutation Verify($username: String, $code: String) {
  verify(username: $username, code: $code) {
      success
      message
  }
}
`;

const AuthService = {
  AUTH_URL: env.AUTH_URL,
  REDIRECT_URL: env.REDIRECT_URL,
  COGNITO_CLIENT_ID: env.COGNITO_CLIENT_ID,
  COGNITO_RESET_PASSWORD_URL: env.COGNITO_RESET_PASSWORD_URL,

  resetPassword: async function(code, email, password) {
    return axios.post(API_URL, {
      query: RESET_PASSWORD,
      variables: {
        email: email,
        code: code,
        password: password
      },
      headers: { 'Content-Type': 'application/json' }
    });
  },
  verifyAccount: async function(code, username) {
    return axios.post(API_URL, {
      query: VERIFY_ACCOUNT,
      variables: {
        username: username,
        code: code
      },
      headers: { 'Content-Type': 'application/json' }
    });

  },
  getTokenViaCode: async function(code) {
      return axios.post(API_URL, {
        query: LOGIN_VIA_CODE,
        variables: {
          code: code
        },
        headers: { 'Content-Type': 'application/json' }
      });
    /*
      .then((response) => {
        let login = response.data.data.login;
        if (login.success === true) {
          localStorage.setItem('AUTH_TOKEN', login.token)
          history.go('/');
        }
      });
    */

  },
  getTokenViaCredentials: function(username, password) {
    return axios.post(API_URL, {
      query: LOGIN_VIA_CREDS,
      variables: {
        username: username,
        password: password
      },
      headers: { 'Content-Type': 'application/json' }
    })

  }
}

export default AuthService;
